/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime : 2020-01-14 22:10:54
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\editingCenter\service\versionTime\versionTime.js
 * @Description:
 */
'use strict';
angular
    .module('versionModule', [
        'editCenPersonalVersionTimeModule',
        'editingCenterPersonalPreviewModule',
        'editCenWeixinPersonalVersionTimeModule',
        'editCenIwoPersonalVersionTimeModule',
        'editCenAppPersonalVersionTimeModule',
        'editCenWebsitePersonalVersionTimeModule',
        'editCenPaperPersonalVersionTimeModule',
        'editCenTelevisionPersonalVersionTimeModule',
        'editCenBroadcastPersonalVersionTimeModule',
        'fusionVersionTimeModule',
        'viewTracesModule'
    ])
    .factory('initVersionService', [
        '$filter',
        function($filter) {
            return {
                getDayContent: function(data, order) {
                    var results = [];
                    // 时间需要反序
                    angular.forEach(data, function(value, key) {
                        var result = {
                            day: '',
                            times: [],
                        };
                        var crtime = '';
                        if (angular.isDefined(value.OPERTIME)) {
                            value.OPERTIME = value.OPERTIME.replace(/-/g, '/');
                            crtime = new Date(value.OPERTIME);
                        } else if (angular.isDefined(value.CRTIME)) {
                            value.CRTIME = value.CRTIME.replace(/-/g, '/');
                            crtime = new Date(value.CRTIME);
                        } else if (angular.isDefined(value.creattime)) {
                            value.creattime = value.creattime.replace(/-/g, '/');
                            crtime = new Date(value.creattime);
                        }
                        var i = 0;
                        var flag = true;
                        for (; i < results.length; i++) {
                            if ($filter('date')(results[i].day, 'yyyy-MM-dd') === $filter('date')(crtime, 'yyyy-MM-dd')) {
                                flag = false;
                                break;
                            }
                        }

                        var method = order ? 'push' : 'unshift';
                        if (flag) {
                            result.day = crtime;
                            result.times[method]({
                                value: value,
                            });
                            results[method](result);
                        } else if (angular.isDefined(results[i])) {
                            results[i].times[method]({
                                value: value,
                            });
                        }
                    });
                    return results;
                },
            };
        },
    ]);
